/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `draft` - Szkic
 * * `published` - Opublikowane
 * * `retired` - Wycofane
 */
export type QuizQuestionStatusEnum = typeof QuizQuestionStatusEnum[keyof typeof QuizQuestionStatusEnum];


export const QuizQuestionStatusEnum = {
  draft: 'draft',
  published: 'published',
  retired: 'retired',
} as const;
